"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function AttributeHeader(_ref) {
  var columnStyle = _ref.columnStyle,
      sortColumn = _ref.sortColumn,
      sortDirection = _ref.sortDirection,
      characteristic = _ref.characteristic,
      handleSortChange = _ref.handleSortChange,
      removeSelectedCharacteristic = _ref.removeSelectedCharacteristic;
  var active = sortColumn === characteristic.answerId;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.HeaderCell, {
    className: "attribute-header",
    style: columnStyle,
    title: characteristic.answerLabel
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "attribute-header__wrapper"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "attribute-header__sort-button",
    onClick: handleSortChange(characteristic.answerId)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "attribute-header__sort-label"
  }, characteristic.answerLabel), active && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    className: "attribute-header__sort-arrow",
    name: sortDirection === 'ascending' ? 'caret up' : 'caret down'
  })), /*#__PURE__*/_react["default"].createElement("button", {
    className: "attribute-header__close-button",
    onClick: function onClick() {
      return removeSelectedCharacteristic(characteristic);
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "close"
  }))));
}

var _default = AttributeHeader;
exports["default"] = _default;